import { buildApiUrl, ADMIN_ENDPOINTS } from '../../configs/api.js'

export default {
  method(payload) {
    return 'POST'
  },

  url(payload) {
    const { ticket, newStatus } = payload || {}

    if (newStatus === 'resolved') {
      return buildApiUrl(ADMIN_ENDPOINTS.SUPPORT_TICKETS_MARK_SOLVED, {
        pathParams: { ticketId: ticket?.id }
      })
    }

    // Pour les autres statuts (pending, closed, open), l'API V3 ne fournit pas
    // d'endpoint dédié. On appelle LIST_ALL (GET sans effet) et on intercepte dans parse.
    return buildApiUrl(ADMIN_ENDPOINTS.SUPPORT_TICKETS_LIST_ALL)
  },

  format(payload) {
    // markAsSolved ne prend pas de body
    return {}
  },

  parse(raw = {}, payload = {}) {
    const { newStatus } = payload || {}

    // Pour les statuts non-API (pending, closed, open) : succès local immédiat
    if (newStatus !== 'resolved') {
      return {
        statusCode: 200,
        message: 'ok',
        data: { updated: true, localOnly: true },
      }
    }

    if (raw?.statusCode !== 201 && raw?.statusCode !== 200) {
      return {
        statusCode: raw?.statusCode || 500,
        message: raw?.message || 'Le serveur semble inaccessible',
        data: raw?.data || null,
      }
    }

    return {
      statusCode: 200,
      message: 'ok',
      data: { updated: true },
    }
  },
}
